import { SmartSubmitConfig } from '../types';

export const smartSubmitDefaultConfig: SmartSubmitConfig = {
  smartSubmitEnabled: false,
};
